import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { addXhrInstrumentationHandler, SENTRY_XHR_DATA_KEY } from '@sentry-internal/browser-utils';
import { defineIntegration, supportsNativeFetch, addFetchInstrumentationHandler, getClient, GLOBAL_OBJ, logger, captureEvent, isSentryRequestUrl, addExceptionMechanism } from '@sentry/core';
import { DEBUG_BUILD } from '../debug-build.js';
var INTEGRATION_NAME = 'HttpClient';
var _httpClientIntegration = function _httpClientIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options = _objectSpread({
    failedRequestStatusCodes: [[500, 599]],
    failedRequestTargets: [/.*/]
  }, options);
  return {
    name: INTEGRATION_NAME,
    setup: function setup(client) {
      _wrapFetch(client, _options);
      _wrapXHR(client, _options);
    }
  };
};

/**
 * Create events for failed client side HTTP requests.
 */
var httpClientIntegration = defineIntegration(_httpClientIntegration);

/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */
function _fetchResponseHandler(options, requestInfo, response, requestInit, error) {
  if (_shouldCaptureResponse(options, response.status, response.url)) {
    var request = _getRequest(requestInfo, requestInit);
    var requestHeaders, responseHeaders, requestCookies, responseCookies;
    if (_shouldSendDefaultPii()) {
      var _parseCookieHeaders2 = _parseCookieHeaders('Cookie', request);
      var _parseCookieHeaders3 = _slicedToArray(_parseCookieHeaders2, 2);
      requestHeaders = _parseCookieHeaders3[0];
      requestCookies = _parseCookieHeaders3[1];
      var _parseCookieHeaders4 = _parseCookieHeaders('Set-Cookie', response);
      var _parseCookieHeaders5 = _slicedToArray(_parseCookieHeaders4, 2);
      responseHeaders = _parseCookieHeaders5[0];
      responseCookies = _parseCookieHeaders5[1];
    }
    var event = _createEvent({
      url: request.url,
      method: request.method,
      status: response.status,
      requestHeaders: requestHeaders,
      responseHeaders: responseHeaders,
      requestCookies: requestCookies,
      responseCookies: responseCookies,
      error: error
    });
    captureEvent(event);
  }
}
function _parseCookieHeaders(cookieHeader, obj) {
  var headers = _extractFetchHeaders(obj.headers);
  var cookies;
  try {
    var cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
    if (cookieString) {
      cookies = _parseCookieString(cookieString);
    }
  } catch (e2) {
    // ignore it if parsing fails
  }
  return [headers, cookies];
}

/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */
function _xhrResponseHandler(options, xhr, method, headers, error) {
  if (_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
    var requestHeaders, responseCookies, responseHeaders;
    if (_shouldSendDefaultPii()) {
      try {
        var cookieString = xhr.getResponseHeader('Set-Cookie') || xhr.getResponseHeader('set-cookie') || undefined;
        if (cookieString) {
          responseCookies = _parseCookieString(cookieString);
        }
      } catch (e3) {
        // ignore it if parsing fails
      }
      try {
        responseHeaders = _getXHRResponseHeaders(xhr);
      } catch (e4) {
        // ignore it if parsing fails
      }
      requestHeaders = headers;
    }
    var event = _createEvent({
      url: xhr.responseURL,
      method: method,
      status: xhr.status,
      requestHeaders: requestHeaders,
      // Can't access request cookies from XHR
      responseHeaders: responseHeaders,
      responseCookies: responseCookies,
      error: error
    });
    captureEvent(event);
  }
}

/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */
function _getResponseSizeFromHeaders(headers) {
  if (headers) {
    var contentLength = headers['Content-Length'] || headers['content-length'];
    if (contentLength) {
      return parseInt(contentLength, 10);
    }
  }
  return undefined;
}

/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */
function _parseCookieString(cookieString) {
  return cookieString.split('; ').reduce(function (acc, cookie) {
    var _cookie$split = cookie.split('='),
      _cookie$split2 = _slicedToArray(_cookie$split, 2),
      key = _cookie$split2[0],
      value = _cookie$split2[1];
    if (key && value) {
      acc[key] = value;
    }
    return acc;
  }, {});
}

/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */
function _extractFetchHeaders(headers) {
  var result = {};
  headers.forEach(function (value, key) {
    result[key] = value;
  });
  return result;
}

/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */
function _getXHRResponseHeaders(xhr) {
  var headers = xhr.getAllResponseHeaders();
  if (!headers) {
    return {};
  }
  return headers.split('\r\n').reduce(function (acc, line) {
    var _line$split = line.split(': '),
      _line$split2 = _slicedToArray(_line$split, 2),
      key = _line$split2[0],
      value = _line$split2[1];
    if (key && value) {
      acc[key] = value;
    }
    return acc;
  }, {});
}

/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */
function _isInGivenRequestTargets(failedRequestTargets, target) {
  return failedRequestTargets.some(function (givenRequestTarget) {
    if (typeof givenRequestTarget === 'string') {
      return target.includes(givenRequestTarget);
    }
    return givenRequestTarget.test(target);
  });
}

/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */
function _isInGivenStatusRanges(failedRequestStatusCodes, status) {
  return failedRequestStatusCodes.some(function (range) {
    if (typeof range === 'number') {
      return range === status;
    }
    return status >= range[0] && status <= range[1];
  });
}

/**
 * Wraps `fetch` function to capture request and response data
 */
function _wrapFetch(client, options) {
  if (!supportsNativeFetch()) {
    return;
  }
  addFetchInstrumentationHandler(function (handlerData) {
    if (getClient() !== client) {
      return;
    }
    var response = handlerData.response,
      args = handlerData.args,
      error = handlerData.error,
      virtualError = handlerData.virtualError;
    var _args = _slicedToArray(args, 2),
      requestInfo = _args[0],
      requestInit = _args[1];
    if (!response) {
      return;
    }
    _fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
  }, false);
}

/**
 * Wraps XMLHttpRequest to capture request and response data
 */
function _wrapXHR(client, options) {
  if (!('XMLHttpRequest' in GLOBAL_OBJ)) {
    return;
  }
  addXhrInstrumentationHandler(function (handlerData) {
    if (getClient() !== client) {
      return;
    }
    var error = handlerData.error,
      virtualError = handlerData.virtualError;
    var xhr = handlerData.xhr;
    var sentryXhrData = xhr[SENTRY_XHR_DATA_KEY];
    if (!sentryXhrData) {
      return;
    }
    var method = sentryXhrData.method,
      headers = sentryXhrData.request_headers;
    try {
      _xhrResponseHandler(options, xhr, method, headers, error || virtualError);
    } catch (e) {
      DEBUG_BUILD && logger.warn('Error while extracting response event form XHR response', e);
    }
  });
}

/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */
function _shouldCaptureResponse(options, status, url) {
  return _isInGivenStatusRanges(options.failedRequestStatusCodes, status) && _isInGivenRequestTargets(options.failedRequestTargets, url) && !isSentryRequestUrl(url, getClient());
}

/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */
function _createEvent(data) {
  var client = getClient();
  var virtualStackTrace = client && data.error && data.error instanceof Error ? data.error.stack : undefined;
  // Remove the first frame from the stack as it's the HttpClient call
  var stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : undefined;
  var message = "HTTP Client Error with status code: ".concat(data.status);
  var event = {
    message: message,
    exception: {
      values: [{
        type: 'Error',
        value: message,
        stacktrace: stack ? {
          frames: stack
        } : undefined
      }]
    },
    request: {
      url: data.url,
      method: data.method,
      headers: data.requestHeaders,
      cookies: data.requestCookies
    },
    contexts: {
      response: {
        status_code: data.status,
        headers: data.responseHeaders,
        cookies: data.responseCookies,
        body_size: _getResponseSizeFromHeaders(data.responseHeaders)
      }
    }
  };
  addExceptionMechanism(event, {
    type: 'http.client',
    handled: false
  });
  return event;
}
function _getRequest(requestInfo, requestInit) {
  if (!requestInit && requestInfo instanceof Request) {
    return requestInfo;
  }

  // If both are set, we try to construct a new Request with the given arguments
  // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
  // In this case, as a fallback, we just use the original request - using both is rather an edge case
  if (requestInfo instanceof Request && requestInfo.bodyUsed) {
    return requestInfo;
  }
  return new Request(requestInfo, requestInit);
}
function _shouldSendDefaultPii() {
  var client = getClient();
  return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}
export { httpClientIntegration };